function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var KyrgyzstanFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "a",
    width: "24",
    height: "18",
    x: "0",
    y: "3",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: 'luminance'
    },
    children: /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M0 3h24v18H0z"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#a)",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#C51918",
      fillRule: "evenodd",
      d: "M0 3v18h24V3H0Z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("mask", {
      id: "b",
      width: "24",
      height: "18",
      x: "0",
      y: "3",
      maskUnits: "userSpaceOnUse",
      style: {
        maskType: 'luminance'
      },
      children: /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 3v18h24V3H0Z",
        clipRule: "evenodd"
      })
    }), /*#__PURE__*/_jsx("g", {
      mask: "url(#b)",
      children: /*#__PURE__*/_jsx("path", {
        fill: "#FFDC17",
        fillRule: "evenodd",
        d: "M11.986 16.4c.08 0 .16-.002.24-.006l.463 1.476.107-1.542c.155-.028.307-.064.456-.107l.793 1.33-.254-1.525c.143-.063.283-.133.418-.21l1.082 1.114-.603-1.427c.125-.093.244-.193.358-.298l1.313.836-.919-1.25c.1-.12.193-.244.28-.372l1.471.513-1.183-1.006c.069-.138.13-.28.186-.426l1.55.163-1.386-.709c.035-.15.062-.302.081-.457l1.546-.196-1.512-.372c0-.157-.01-.312-.026-.464l1.457-.544-1.555-.017a4.417 4.417 0 0 0-.134-.446l1.29-.862-1.517.34a4.424 4.424 0 0 0-.235-.405L16.808 8.4l-1.396.677a4.49 4.49 0 0 0-.323-.34l.762-1.343-1.2.977a4.493 4.493 0 0 0-.393-.259l.428-1.478-.938 1.223a4.481 4.481 0 0 0-.445-.161l.073-1.534-.628 1.403a4.53 4.53 0 0 0-.471-.055L11.992 6l-.285 1.508a4.53 4.53 0 0 0-.472.054l-.628-1.401.074 1.53c-.153.046-.302.1-.448.162l-.936-1.22.428 1.473c-.138.08-.27.166-.398.26l-1.194-.973.758 1.336a4.493 4.493 0 0 0-.327.343L7.176 8.4l1.048 1.126a4.437 4.437 0 0 0-.238.409l-1.507-.338 1.282.856a4.384 4.384 0 0 0-.136.453l-1.546.016 1.448.54a4.462 4.462 0 0 0-.027.47l-1.502.37 1.535.195c.02.157.047.312.083.463l-1.376.704 1.54-.162c.055.148.118.292.189.431l-1.177 1 1.463-.51c.088.13.182.255.283.375l-.913 1.244 1.306-.832c.115.106.236.206.362.3l-.6 1.421 1.078-1.11c.136.077.277.147.421.21l-.254 1.52.792-1.327c.15.044.302.08.458.107l.107 1.54.463-1.476c.075.004.152.006.229.006Zm3.375-4.463c0 1.863-1.523 3.374-3.402 3.374-1.878 0-3.402-1.51-3.402-3.374s1.524-3.375 3.402-3.375c1.88 0 3.402 1.511 3.402 3.375Zm-3.38 2.627a2.572 2.572 0 0 0 2.361-3.595 3.892 3.892 0 0 0-2.075.754l-.369.277-.343-.297c-.33-.285-.966-.606-1.942-.716a2.572 2.572 0 0 0 2.368 3.577Zm-1.855-4.354a2.564 2.564 0 0 1 1.856-.79c.717 0 1.366.294 1.833.768-.734.085-1.357.269-1.862.555-.451-.258-1.06-.433-1.827-.533Z",
        clipRule: "evenodd"
      })
    })]
  })]
}));
//# sourceMappingURL=Kyrgyzstan.js.map